module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-20-6ee3a8508e5aab53da476f909ca446e7.svg";